export const REGULAR = 400;
export const MEDIUM = 500;
export const BOLD = 700;
